// Every USDT coin's last price, 24h change and volume (GET /api/market/tickers,
// cached 10 s on the server), re-read every 15 s. Null until the first answer
// or while the backend doesn't serve it: the coin list then shows what the
// desk scan knows.
import { useEffect, useState } from "react";

export interface Ticker {
  symbol: string;
  price: number;
  /** 24h change, percent. */
  changePct: number;
  /** 24h volume, USDT. */
  volume: number;
  high: number;
  low: number;
}

const POLL_MS = 15_000;

export function useTickers(): Map<string, Ticker> | null {
  const [tickers, setTickers] = useState<Map<string, Ticker> | null>(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = await fetch("/api/market/tickers");
        const json = await res.json();
        if (!alive || !json.success || !Array.isArray(json.data)) return;
        setTickers(new Map((json.data as Ticker[]).map(t => [t.symbol, t])));
      } catch {
        /* keep the last answer; try again next poll */
      }
    };
    // First load always; polls skip a hidden tab, which refreshes on return.
    load();
    const id = setInterval(() => { if (!document.hidden) load(); }, POLL_MS);
    const onVisible = () => { if (!document.hidden) load(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      alive = false;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
  return tickers;
}
